export abstract class ServiceBase {
  private initializationPromise: Promise<void> = null;

  async initialize() {
    await (this.initializationPromise = this.initializeService());
  }

  get ready(): Promise<unknown> {
    return Promise.all([...this.runtimeDependencies.map(d => d.ready), this.initializationPromise ?? this.initialize()]);
  }

  protected async initializeService(): Promise<void> { return; }
  protected get runtimeDependencies(): ServiceBase[] { return []; }
}
